export const MINUTES_PER_HOUR = 60;

export const LoadingStatus = {
  LOADING: 'LOADING',
  INIT: 'INIT',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  UPDATE: 'UPDATE',
};
